import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreTextField } from 'src/components/core'

const HeaderSettingsLanguage = props => {
  const {
    classes,
    selectedStartValue,
    selectedResumeValue,
    onButtonTextChange,
    isLoading,
  } = props

  const handleChangeResumeCourse = value => {
    onButtonTextChange('resume', value)
  }

  const handleChangeStartCourse = value => {
    onButtonTextChange('start', value)
  }

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <Typography className={classes.header}>Button language</Typography>
      </div>
      <div className={classes.courseDiv}>
        <CoreTextField
          value={selectedResumeValue}
          onChange={e => handleChangeResumeCourse(e.target.value)}
          fullWidth
          label="Resume Course"
          disabled={isLoading}
        />
      </div>
      <div className={classes.courseDiv}>
        <CoreTextField
          label="Start Course"
          value={selectedStartValue}
          onChange={e => handleChangeStartCourse(e.target.value)}
          fullWidth
          disabled={isLoading}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsLanguage)
